import { render, staticRenderFns } from "./HearingAidCreate.vue?vue&type=template&id=2251d14c&"
import script from "./HearingAidCreate.vue?vue&type=script&lang=js&"
export * from "./HearingAidCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports